<script setup lang="ts">
import WizardTabWithSidebar from '../WizardTabWithSidebar.vue'
import BaseButtonPrimary from '../../base/BaseButtonPrimary.vue'
import { inject, ref } from 'vue'
import { createCompanyProfile } from '../../../utilities/api'
import { useLegalAccountDataState } from '../../../utilities/account/useAccountDataLegal'
const { navigateToTab } = inject('navigation')

function navigateToNaturalProfileTab() {
    navigateToTab('natural_personal_data')
}

const disabledLegalButton = ref(false)
async function navigateToLegalProfileTab() {
    if (!useLegalAccountDataState().legalProfile?.legal_profile_uid) {
        disabledLegalButton.value = true
        await createCompanyProfile()
        await useLegalAccountDataState().fetchAccountData()
        disabledLegalButton.value = false
    }
    navigateToTab('legal_company_information')
}
</script>

<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <p class="text-semibold w-full py-2 text-center text-2xl text-gray-700">
                {{ $t('widget.sign_up_as') }}
            </p>

            <div class="space-y-4 py-4">
                <BaseButtonPrimary class="mx-auto block min-w-[400px]" size="xl" @click="navigateToNaturalProfileTab">{{
                    $t('widget.natural_person')
                }}</BaseButtonPrimary>
                <BaseButtonPrimary
                    :disabled="disabledLegalButton"
                    class="mx-auto block min-w-[400px]"
                    size="xl"
                    @click="navigateToLegalProfileTab"
                    >{{ $t('widget.legal_entity') }}</BaseButtonPrimary
                >
            </div>
        </template>

        <template #sidebar>
            <div
                class="prose prose-slate leading-normal text-gray-800 prose-p:my-3 prose-ul:mb-3 prose-ul:mt-0 prose-li:mt-1"
                v-html="$t('esac_widget_sidebar.natural_legal_select')"></div>
        </template>
    </WizardTabWithSidebar>
</template>

<style scoped></style>
